import { render, staticRenderFns } from "./TutorialPrompt.vue?vue&type=template&id=2b7a3054&"
import script from "./TutorialPrompt.vue?vue&type=script&lang=js&"
export * from "./TutorialPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports